import { defineMessages } from 'react-intl';

export const commonCardI18n: {
	createWhiteboardTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createWhiteboardDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createWhiteboardCTA: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	addProfilePictureTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	addProfilePictureCTA: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	createWhiteboardTitle: {
		id: 'experiment-home-onboarding-takeover-v2.create-whiteboard.title',
		defaultMessage: 'Brainstorm on a whiteboard',
		description:
			'This will be shown as a title on a card embedded into the home screen as a part of onboarding.',
	},
	createWhiteboardDescription: {
		id: 'experiment-home-onboarding-takeover-v2.create-whiteboard.description',
		defaultMessage: 'Dream up new ideas and visualize your work.',
		description:
			'This will be shown as a description on a card embedded into the home screen as a part of onboarding.',
	},
	createWhiteboardCTA: {
		id: 'experiment-home-onboarding-takeover-v2.create-whiteboard.cta',
		defaultMessage: 'Create whiteboard',
		description:
			'This will be shown on a button embedded into the home screen as a part of onboarding. Clicking the button will create a whiteboard and land them in the whiteboard editor',
	},
	addProfilePictureTitle: {
		id: 'experiment-home-onboarding-takeover-v2.add-profile-picture.title',
		defaultMessage: 'Add your profile photo',
		description:
			'This will be shown as a title on a card embedded into the home screen as a part of onboarding.',
	},
	addProfilePictureCTA: {
		id: 'experiment-home-onboarding-takeover-v2.add-profile-picture.cta',
		defaultMessage: 'Add photo',
		description:
			'This will be shown on a button embedded into the home screen as a part of onboarding. Clicking the button will open a new settings page where they can add a profile photo',
	},
});
